import React from 'react';
import Form, { FormContext, FormUtils } from '../../../../components/molecules/Form';
import FormSubmitOrCancel from '../../../../components/molecules/Form/components/FormSubmitOrCancel/FormSubmitOrCancel';
import LiveRegion from '../../../../components/atoms/LiveRegion/LiveRegion';
import IForm from '../../../../types/IForm';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import { Namespace } from '../../../../translation/namespace';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Strong } from '../../../../components/atoms/Strong/Strong';

type DeletableItemFormProps = {
  model?: IForm;
  onSuccess: () => void;
  ariaLabel: string;
  cancelAction: () => void;
};

export default function DeletableItemForm({ model, onSuccess, ariaLabel, cancelAction }: DeletableItemFormProps) {
  const { t } = useSonTranslation(Namespace.ImageGallery);

  if (!model) {
    return null;
  }

  return (
    <Form
      id="image-gallery-image-delete-form"
      model={model}
      onSuccess={() => {
        setTimeout(() => {
          onSuccess();
        }, 2000);
      }}
      ariaLabel={ariaLabel}
    >
      <FormContext.Consumer>
        {({ getStatus, status }) => {
          return (
            <>
              <FormSubmitOrCancel hierarchy={3} headline={ariaLabel} cancelAction={cancelAction} />
              <LiveRegion htmlTag="div" invisible={false}>
                {getStatus(
                  {
                    [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t('deleteForm.status.sending')),
                    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(
                      <>
                        {t('deleteForm.status.success')}
                        <Strong> {t('deleteForm.status.successForward')}</Strong>
                      </>,
                    ),
                    [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('deleteForm.status.fail')),
                  },
                  status,
                )}
              </LiveRegion>
            </>
          );
        }}
      </FormContext.Consumer>
    </Form>
  );
}
